import { timer } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { NG_ASYNC_VALIDATORS } from '@angular/forms';
import * as i0 from '@angular/core';
import { InjectionToken, Directive, Optional, Inject, Input, NgModule } from '@angular/core';
import sha1 from 'crypto-js/sha1';
import * as i1 from '@angular/common/http';
import { HttpClientModule } from '@angular/common/http';

const PasswordCheckerConfigValue = new InjectionToken('PASSWORD_CHECKER_CONFIG');

class PasswordCheckerLibDirective {
    constructor(http, config) {
        this.http = http;
        if (!config) {
            // default initialization in constructor didn't work.
            // conflict with @Optional()?
            config = {};
        }
        this.pwnedPasswordApi =
            config.pwnedPasswordApi
                || 'https://api.pwnedpasswords.com/range/';
        this.pwnedPasswordMinimumOccurrenceForError =
            config.pwnedPasswordMinimumOccurrenceForError
                || 1;
        this.pwnedPasswordApiCallDebounceTime =
            config.pwnedPasswordApiCallDebounceTime
                || 400;
    }
    validate(control) {
        const pw = ''.concat(control.value);
        return timer(this.pwnedPasswordApiCallDebounceTime).pipe(map(() => {
            const pwSha1 = sha1(pw).toString().toUpperCase();
            return {
                firstPart: pwSha1.substring(0, 5),
                lastPart: pwSha1.substring(5),
            };
        }), switchMap((hash) => this.http.get(`${this.pwnedPasswordApi}${hash.firstPart}`, { responseType: 'text' }).pipe(map(passwords => passwords.split(/[\r\n]+/)), map(passwords => passwords.map((password) => {
            const split = password.split(':');
            return {
                hash: split[0],
                count: parseInt(split[1], 10),
            };
        })), map(passwords => passwords.find(password => password.hash === hash.lastPart)))), map(password => password && password.count >= this.pwnedPasswordMinimumOccurrenceForError
            ? { pwnedPasswordOccurrence: password.count }
            : null));
    }
}
PasswordCheckerLibDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: PasswordCheckerLibDirective, deps: [{ token: i1.HttpClient }, { token: PasswordCheckerConfigValue, optional: true }], target: i0.ɵɵFactoryTarget.Directive });
PasswordCheckerLibDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.0.3", type: PasswordCheckerLibDirective, selector: "[pwnedPasswordValidator][formControlName], [pwnedPasswordValidator][ngModel],[pwnedPasswordValidator][formControl]", inputs: { pwnedPasswordApi: "pwnedPasswordApi", pwnedPasswordMinimumOccurrenceForError: "pwnedPasswordMinimumOccurrenceForError", pwnedPasswordApiCallDebounceTime: "pwnedPasswordApiCallDebounceTime" }, providers: [
        {
            provide: NG_ASYNC_VALIDATORS,
            useExisting: PasswordCheckerLibDirective,
            multi: true,
        },
    ], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: PasswordCheckerLibDirective, decorators: [{
            type: Directive,
            args: [{
                    // eslint-disable-next-line  @angular-eslint/directive-selector
                    selector: '[pwnedPasswordValidator][formControlName], [pwnedPasswordValidator][ngModel],[pwnedPasswordValidator][formControl]',
                    providers: [
                        {
                            provide: NG_ASYNC_VALIDATORS,
                            useExisting: PasswordCheckerLibDirective,
                            multi: true,
                        },
                    ]
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [PasswordCheckerConfigValue]
                }] }]; }, propDecorators: { pwnedPasswordApi: [{
                type: Input
            }], pwnedPasswordMinimumOccurrenceForError: [{
                type: Input
            }], pwnedPasswordApiCallDebounceTime: [{
                type: Input
            }] } });

class PasswordCheckerModule {
    static forRoot(config = {}) {
        return {
            ngModule: PasswordCheckerModule,
            providers: [
                {
                    provide: PasswordCheckerConfigValue,
                    useValue: config,
                }
            ]
        };
    }
}
PasswordCheckerModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: PasswordCheckerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
PasswordCheckerModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.0.3", ngImport: i0, type: PasswordCheckerModule, declarations: [PasswordCheckerLibDirective], imports: [HttpClientModule], exports: [PasswordCheckerLibDirective] });
PasswordCheckerModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: PasswordCheckerModule, imports: [HttpClientModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: PasswordCheckerModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [PasswordCheckerLibDirective],
                    imports: [HttpClientModule],
                    exports: [PasswordCheckerLibDirective]
                }]
        }] });

/*
 * Public API Surface of password-checker-lib
 */

/**
 * Generated bundle index. Do not edit.
 */

export { PasswordCheckerLibDirective, PasswordCheckerModule };
